"use client";

import { c as _c } from "react/compiler-runtime";
import { joinAffiliateProgram } from "@/actions/affiliate";
import ThankYouDrawer from "@/app/course/(course-enroll)/[courseSlug]/enroll/_components/thank-you-drawer";
import { RainbowButton } from "@/components/magicui/rainbow-button";
import { Button } from "@/components/ui/button";
import { DialogClose, DialogFooter } from "@/components/ui/dialog";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PaymentMethod } from "@/prisma/generated/client";
import { PAYMENT_METHODS, ZAffiliateCreateSchema, ZAffiliateDBSchema } from "@/types/types";
import { affiliateCreateSchema } from "@/types/zod-types";
import { generateReferralCode } from "@/utils/generators";
import { tryCatch } from "@/utils/validators";
import { useAuth } from "@clerk/nextjs";
import { zodResolver } from "@hookform/resolvers/zod";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { toast } from "sonner";
type AffiliateSignUpFormProps = {
  onCloseAction: () => void;
};
export default function AffiliateSignUpForm(t0) {
  const $ = _c(42);
  const {
    onCloseAction
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      resolver: zodResolver(affiliateCreateSchema),
      defaultValues: {
        paymentMethod: "EASYPAISA"
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const form = useForm(t1);
  const {
    control,
    setValue,
    handleSubmit,
    reset,
    formState: t2
  } = form;
  const {
    isDirty,
    isSubmitting
  } = t2;
  const [showCongratulationsDrawer, setShowCongratulationsDrawer] = useState(false);
  const {
    userId
  } = useAuth();
  const router = useRouter();
  let t3;
  if ($[1] !== control) {
    t3 = {
      control,
      name: "paymentMethod"
    };
    $[1] = control;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const paymentMethod = useWatch(t3);
  let t4;
  if ($[3] !== reset || $[4] !== userId) {
    t4 = async function handleCreateAffiliate(formData) {
      const formDataFull = {
        ...formData,
        referralCode: generateReferralCode(),
        userId
      };
      const {
        error
      } = await tryCatch(joinAffiliateProgram(formDataFull));
      if (error) {
        toast.error(error.message);
        return;
      }
      setShowCongratulationsDrawer(true);
      reset();
    };
    $[3] = reset;
    $[4] = userId;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleCreateAffiliate = t4;
  let t5;
  if ($[6] !== handleCreateAffiliate || $[7] !== handleSubmit) {
    t5 = handleSubmit(handleCreateAffiliate);
    $[6] = handleCreateAffiliate;
    $[7] = handleSubmit;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== setValue) {
    t6 = t7 => {
      const {
        field
      } = t7;
      return <FormItem><FormLabel>Payment Method</FormLabel><Select onValueChange={value => setValue("paymentMethod", value, {
          shouldDirty: true
        })}><FormControl><SelectTrigger><SelectValue placeholder={field.value ?? "Select payment method"} /></SelectTrigger></FormControl><SelectContent align="start" className="max-w-52">{PAYMENT_METHODS.map(_temp)}</SelectContent></Select><FormMessage /></FormItem>;
    };
    $[9] = setValue;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== control || $[12] !== t6) {
    t7 = <FormField control={control} name="paymentMethod" render={t6} />;
    $[11] = control;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== control || $[15] !== paymentMethod) {
    t8 = (paymentMethod === "EASYPAISA" || paymentMethod === "JAZZCASH") && <FormField control={control} name="phoneNumber" render={_temp2} />;
    $[14] = control;
    $[15] = paymentMethod;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== control || $[18] !== paymentMethod) {
    t9 = paymentMethod === "BANK_TRANSFER" && <><FormField control={control} name="bankName" render={_temp3} /><FormField control={control} name="accountHolder" render={_temp4} /><FormField control={control} name="accountNumber" render={_temp5} /><FormField control={control} name="iban" render={_temp6} /></>;
    $[17] = control;
    $[18] = paymentMethod;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t10 = <div className="max-h-72 space-y-4 overflow-y-auto p-1">{t7}{t8}{t9}</div>;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <DialogClose asChild={true}><Button variant="outline" className="w-full sm:w-fit">Cancel</Button></DialogClose>;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  const t12 = !isDirty || isSubmitting;
  const t13 = isSubmitting ? "cursor-not-allowed" : "";
  let t14;
  if ($[25] !== t12 || $[26] !== t13) {
    t14 = <DialogFooter className="mt-6 flex gap-2 sm:mt-4">{t11}<RainbowButton type="submit" disabled={t12} className={t13}>Join now</RainbowButton></DialogFooter>;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t10 || $[29] !== t14 || $[30] !== t5) {
    t15 = <form onSubmit={t5} className="mx-auto w-full items-center gap-4 pb-4">{t10}{t14}</form>;
    $[28] = t10;
    $[29] = t14;
    $[30] = t5;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== onCloseAction || $[33] !== router) {
    t16 = () => {
      onCloseAction();
      router.refresh();
    };
    $[32] = onCloseAction;
    $[33] = router;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== showCongratulationsDrawer || $[36] !== t16) {
    t17 = <ThankYouDrawer title={"\uD83C\uDF89 You are an affiliate now!"} subtitle="Thank you for signing up. You can start referring your friends now!" showDrawer={showCongratulationsDrawer} setShowDrawerAction={setShowCongratulationsDrawer} onCloseAction={t16} />;
    $[35] = showCongratulationsDrawer;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== form || $[39] !== t15 || $[40] !== t17) {
    t18 = <Form {...form}>{t15}{t17}</Form>;
    $[38] = form;
    $[39] = t15;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  return t18;
}

// Recycled

// 15 Feb 2026

// const paymentMethod = watch("paymentMethod");
function _temp6(t0) {
  const {
    field: field_4
  } = t0;
  return <FormItem><FormLabel>IBAN</FormLabel><FormControl><Input {...field_4} value={field_4.value || ""} placeholder="e.g. PK36SCBL0000001123456702" /></FormControl><FormMessage /></FormItem>;
}
function _temp5(t0) {
  const {
    field: field_3
  } = t0;
  return <FormItem><FormLabel>Account Number</FormLabel><FormControl><Input {...field_3} value={field_3.value || ""} placeholder="e.g. 12345678901234" /></FormControl><FormMessage /></FormItem>;
}
function _temp4(t0) {
  const {
    field: field_2
  } = t0;
  return <FormItem><FormLabel>Account Holder Name</FormLabel><FormControl><Input {...field_2} value={field_2.value || ""} placeholder="e.g. Muhammad Ali" /></FormControl><FormMessage /></FormItem>;
}
function _temp3(t0) {
  const {
    field: field_1
  } = t0;
  return <FormItem><FormLabel>Bank Name</FormLabel><FormControl><Input {...field_1} value={field_1.value || ""} placeholder="e.g. Faysal Bank" /></FormControl><FormMessage /></FormItem>;
}
function _temp2(t0) {
  const {
    field: field_0
  } = t0;
  return <FormItem><FormLabel>Your phone number</FormLabel><FormControl><Input {...field_0} value={field_0.value || ""} type="tel" placeholder="e.g. 03171234567" /></FormControl><FormMessage /></FormItem>;
}
function _temp(item) {
  return <SelectItem key={item.id} value={item.id} className="max-w-48">{item.title}</SelectItem>;
}